import { AREAS } from "@/data/site";

export const Marquee = ({ items = AREAS, dark = false }) => {
  const row = [...items, ...items, ...items];
  return (
    <div data-testid="area-marquee" className={`marquee-wrap relative overflow-hidden border-y py-7 ${dark ? "border-white/10 bg-[#14263D] text-white" : "border-[#14263D]/10 bg-[#F8F7F3] text-[#14263D]"}`} aria-label={`Serving ${items.join(", ")}`}>
      <div className="marquee-track flex w-max whitespace-nowrap" aria-hidden="true">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {row.map((a, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`px-8 font-display text-4xl md:text-6xl ${i % 2 ? "italic" : ""}`}>{a}</span>
                <svg viewBox="0 0 20 20" className="h-4 w-4 shrink-0 text-[#A52A32]"><path d="M10 1 L18 4 V10 C18 15 14 18 10 19 C6 18 2 15 2 10 V4 Z" fill="currentColor" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
